// extracted by mini-css-extract-plugin
module.exports = {"cards-container":"WxXWo","cardsContainer":"WxXWo","card-icon":"y2Z8L","cardIcon":"y2Z8L","more-label":"ii0bX","moreLabel":"ii0bX"};